/** Datums-, Zeit- und Format-Helper. Output immer Europe/Berlin via Browser-Zeitzone. */

export const DAY_NAMES = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
export const DAY_NAMES_LONG = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];
export const MONTH_NAMES = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember",
];

export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function pad(n: number): string { return String(n).padStart(2, "0"); }

export function isoToDate(iso: string): Date {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function dateToIso(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** ISO-Timestamp (UTC vom Backend) → lokales YYYY-MM-DD. */
export function localDateFromIso(iso: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso.slice(0, 10);
  return dateToIso(d);
}

/** ISO-Timestamp → lokales HH:MM. */
export function localHM(iso: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    const m = iso.match(/T(\d{2}):(\d{2})/);
    return m ? `${m[1]}:${m[2]}` : "";
  }
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function hmToMinutes(hm: string): number {
  if (!hm) return 0;
  const [h, m] = hm.split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
}

export function durHours(startIso: string, endIso: string, pause = 0): number {
  if (!startIso || !endIso) return 0;
  const s = new Date(startIso).getTime();
  const e = new Date(endIso).getTime();
  if (Number.isNaN(s) || Number.isNaN(e)) return 0;
  return Math.max(0, (e - s) / 3_600_000 - pause);
}

export function fmtHours(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return "—";
  const a = Math.abs(n);
  const h = Math.floor(a);
  const m = Math.round((a - h) * 10);
  return `${h},${m} h`;
}

export function fmtEUR(n: number | null | undefined): string {
  const v = n ?? 0;
  return v.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
}

export function initials(name: string): string {
  if (!name) return "?";
  return name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]).join("").toUpperCase();
}

const PROJECT_COLORS = [
  "#d97045", "#7aa8c8", "#8aa455", "#b59edc",
  "#e3b061", "#6d8a7a", "#a8694a", "#5d8aa8",
];
export function projectColor(id: string, farbe?: string): string {
  if (farbe && /^#[0-9a-f]{6}$/i.test(farbe)) return farbe;
  if (!id) return PROJECT_COLORS[0];
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return PROJECT_COLORS[h % PROJECT_COLORS.length];
}
